import { getIn, useFormikContext } from "formik"
import * as Yup from 'yup'

import { FormikBillingDetails, FormikInspectorAgreeCheck, billingDetailsSchema, FormikNotesArea } from "../../../../../../components/widgets"
import { useEffect } from "react"
import { IWebFileAttachment } from "../../../../../core/applications"

// Site Inspection
export interface IDLMTravelNote  {
  verdict: string
  workflow: string
  note: string
  noteAttachments: Array<IWebFileAttachment>
  inspectorAgree: boolean
}

export const initDLMTravelNoteValues = {
  verdict: '',
  workflow: '',
  note: '',
  noteAttachments: [],
  inspectorAgree: false,
}


const InspectorAgreeStates = [
  'Sampling',
  'Testing',
]

export const DLMTravelNoteSchema: any = Yup.object({
  appState: Yup.string().trim(),
  verdict: Yup.string().trim(),
  workflow: Yup.string().trim(),
  note: Yup.string().trim().label('Note')
  .when('verdict', {
    is : (verdict: string) => (verdict !== 'approved'),
    then: (schema) => schema.required(),    
  }),  
  noteAttachments: Yup.array(),
  inspectorAgree: Yup.bool().label('Confirmation')
  .when(['appState', 'verdict'], {
    is : (appState: string, verdict: string) => (InspectorAgreeStates.includes(appState) && verdict === 'approved'),
    then: (schema) => schema.oneOf([true], 'Must be checked'),    
  }),
}).concat(billingDetailsSchema);

export const DLMTravelNoteForm = () => {
  
  const { values, setFieldValue, validateField } = useFormikContext();

  const verdict = getIn(values, 'verdict') ?? '';    
  const appState = getIn(values, 'appState') ?? '';
  

  useEffect(() => {
    setFieldValue('billingRequired', (verdict && ['approved','rejected'].includes(verdict) && appState !== 'Testing') ? 'YES' : 'NO', true);
    validateField('note');
    validateField('inspectorAgree');  
  }, [verdict, appState, setFieldValue, validateField]);
  
  return (
  <>
  <FormikBillingDetails />
  <FormikNotesArea label={appState === 'Testing' ? 'Testing Result' : "Note"} required={(verdict !== 'approved')} />
  { (InspectorAgreeStates.includes(appState) && verdict === 'approved') && 
  <FormikInspectorAgreeCheck />
  }
  </>
  )
}